// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Components
import Button from './Button';

// Styles
import './LinkButton.scss';

const LinkButton = (props) => (
    <Button {...props} className={classNames('LinkButton', props.className)}>
        {props.children}
    </Button>
);

LinkButton.propTypes = {
    children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string]),
    className: PropTypes.string,
    onClick: PropTypes.func,
};

export default LinkButton;
